import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const navLinks = [
  { name: "Home", path: "/", testId: NAV.homeLink },
  { name: "About", path: "/about", testId: NAV.aboutLink },
  { name: "Services", path: "/services", testId: NAV.servicesLink },
  { name: "Assessments", path: "/assessments", testId: NAV.assessmentsLink },
  { name: "FAQ", path: "/faq", testId: NAV.faqLink },
  { name: "Contact", path: "/contact", testId: NAV.contactLink },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            data-testid={NAV.logo}
            className="flex flex-col"
          >
            <span className="font-heading text-xl font-bold text-white tracking-wide">
              MODERN MINDS
            </span>
            <span className="font-body text-[10px] text-[#7C9885] tracking-wider uppercase">
              Center for Child Psychology
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={link.testId}
                className={`nav-link font-body font-medium text-sm transition-colors ${
                  isActive(link.path)
                    ? "text-[#7C9885]"
                    : "text-[#E2E8F0] hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <a
            href="https://consult.modernminds.co.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid={NAV.bookingBtn}
            className="hidden lg:inline-flex btn-gold rounded px-5 py-2 font-body font-semibold text-sm"
          >
            Book Session
          </a>

          {/* Mobile Menu Button */}
          <button
            data-testid={NAV.mobileMenuBtn}
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 text-white hover:text-[#C9A962] transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden mobile-menu-enter pb-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`${link.testId}-mobile`}
                  onClick={() => setIsOpen(false)}
                  className={`font-body font-medium text-sm py-2 transition-colors ${
                    isActive(link.path)
                      ? "text-[#7C9885]"
                      : "text-[#E2E8F0] hover:text-white"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://consult.modernminds.co.in"
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${NAV.bookingBtn}-mobile`}
                className="btn-gold rounded px-5 py-2.5 font-body font-semibold text-sm text-center mt-2"
              >
                Book Session
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
